module.exports = __webpack_public_path__ + "img/outer-card.e5f30bfb.svg";